<!-- New Banner at the top -->
<div class="alert alert-info text-center" role="alert">
  <strong>Enjoy full access to all features for free up to {{FreeMB}}MB—No signup required!</strong>
</div>


